import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, FormHelperText, Grid, Paper, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { GridExpandMoreIcon } from '@mui/x-data-grid';
import convertImageToWeb from '../../../../../utils/convertImageToWeb';
import errorFormat from '../../../../../utils/errorFormat';
import configSiteUrls from '../../../configs/configSiteUrls';
import { useAddLicitacaoAnexosMutation, useGetLicitacaoAnexosQuery, useRemoveLicitacaoAnexoExcluidoMutation } from '../licitacaoAnexoApiSlice';

//import { LicitacaoAnexo } from '../types/LicitacaoAnexo';
import GeralAnexosUpload from './GeralAnexosUpload';
import { useAddLicitacaoMutation, useGetLicitacaoQuery } from './licitacaoApiSlice';
import { LicitacaoAnexo } from '../types/LicitacaoAnexo';
import { ISlicitacao, Licitacao, LicitacaoDTO, LicitacaoFormaContratacao, LicitacaoStatusProcesso } from '../types/Licitacao';
import TxtLicitacaoFormaContratacaoSite from '../../../../autoComplete/TxtLicitacaoFormaContratacaoSite';
import TxtLicitacaoStatusProcessoSite from '../../../../autoComplete/TxtLicitacaoStatusProcessoSite';

export const LicitacaoCreate = () => {
  const [licitacao, SetLicitacao] = useState<Licitacao>(ISlicitacao);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [createLicitacao, status] = useAddLicitacaoMutation();
  const [loading, setLoading] = useState(false);
  const [createAnexos, statusCreateAnexos] = useAddLicitacaoAnexosMutation();
  const [removeAnexosExcluidos, statusRemoveExcluido] = useRemoveLicitacaoAnexoExcluidoMutation();
  const navigate = useNavigate();

  //verificar se for edicao ele pega o id e faz a consulta
  const id = useParams().id || '';
  const { data, isFetching, error } = useGetLicitacaoQuery(id);
  useEffect(() => {
    if (data) {
      SetLicitacao(data);
    }
  }, [data, error, isFetching]);

  const [licitacaoAnexoParaSalvar, setLicitacaoAnexoParaSalvar] = useState<File[]>([]);
  const [licitacaoAnexoSalvo, setLicitacaoAnexoSalvo] = useState<LicitacaoAnexo[] | null>(null);
  const { data: dataAnexo } = useGetLicitacaoAnexosQuery({ idLicitacao: id }, { skip: !id });
  useEffect(() => {
    if (dataAnexo) setLicitacaoAnexoSalvo(dataAnexo);
  }, [dataAnexo]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const cursorPosition = e.target.selectionStart;

    SetLicitacao(prev => ({
      ...prev,
      [name]: value
    }));

    // Aguarde até que o DOM seja atualizado
    setTimeout(() => {
      const input = e.target;
      input.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  };

  const handleFileAnexoChange = async (files: File[]) => {
    const convertedFiles = await Promise.all(files.map(file => convertImageToWeb(file)));
    setLicitacaoAnexoParaSalvar(prev => [...prev, ...convertedFiles]);
  };

  const handleOnDeleteParaSalvar = (index: number) => {
    setLicitacaoAnexoParaSalvar(prev => prev.filter((_, i) => i !== index));
  };

  function handleOnDeleteSalvo(fileId: string) {
    setLicitacaoAnexoSalvo(prev => {
      if (prev) {
        return prev.map(arq => (arq.id === fileId ? { ...arq, excluido: true } : arq));
      }
      return null; // ou um array vazio se preferir
    });
  }

  const handleExcluirTodosAnexos = () => {
    setLicitacaoAnexoParaSalvar([]);
    setLicitacaoAnexoSalvo(null);
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const parms: LicitacaoDTO = {
      id: licitacao.id || '',
      processo: licitacao.processo || '',
      objeto: licitacao.objeto || '',
      pregao: licitacao.pregao || '',
      idSituacao: licitacao.situacao.id || '',
      idModalidade: licitacao.modalidade.id || '',
      fiscal: licitacao.fiscal || ''
    };

    setLoading(true);
    const result: any = await createLicitacao(parms);
    const idLicitacao = result?.data?.id;

    if (idLicitacao) {
      if (licitacaoAnexoParaSalvar.length) {
        const formData = new FormData();
        licitacaoAnexoParaSalvar.forEach(file => formData.append('imagens', file));
        formData.append('licitacaoID', idLicitacao);
        createAnexos(formData);
      }

      if (licitacaoAnexoSalvo && licitacaoAnexoSalvo?.length) {
        let licitacaoAnexoExcluido: { idAnexo: string }[];

        licitacaoAnexoExcluido = licitacaoAnexoSalvo.filter(it => it.excluido === true).map(it => ({ idAnexo: it.id }));

        if (licitacaoAnexoExcluido.length) {
          const formData = new FormData();
          formData.append('licitacaoID', idLicitacao);
          formData.append('anexosExcluidos', JSON.stringify(licitacaoAnexoExcluido));
          removeAnexosExcluidos(formData);
        }
      }

      handleExcluirTodosAnexos();

      navigate(configSiteUrls.SITE_LICITACAO_LIST);
    }
    setLoading(false);
  }

  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          mt: 4
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: {
              xs: '100%', // 100% em telas pequenas
              sm: '90%', // 90% em telas médias ou maiores
              md: '90%',
              lg: '90%'
            },
            maxWidth: '1200px', // Limite opcional
            p: 2
          }}
        >
          <Typography variant="h6" component="h1" sx={{ mb: 2 }}>
            {licitacao.id ? 'Edição:' : 'Inclusão:'} LICITAÇÃO
          </Typography>

          <form onSubmit={handleSubmit} method="POST">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField required label="Processo:" name="processo" onChange={handleChange} size="small" inputProps={{ maxLength: 30 }} value={licitacao.processo} />
                  <FormHelperText>{licitacao.processo?.length}/30 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField required label="Pregão:" name="pregao" onChange={handleChange} size="small" inputProps={{ maxLength: 30 }} value={licitacao.pregao} />
                  <FormHelperText>{licitacao.pregao?.length}/30 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField required multiline rows={4} label="Objeto:" name="objeto" onChange={handleChange} size="small" inputProps={{ maxLength: 500 }} value={licitacao.objeto} />
                  <FormHelperText>{licitacao.objeto?.length}/500 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TxtLicitacaoStatusProcessoSite
                    isdisabled={false}
                    isLoading={false}
                    required={false}
                    value={licitacao.situacao}
                    handleSearchChange={it => {
                      SetLicitacao(prev => ({
                        ...prev,
                        situacao: it as LicitacaoStatusProcesso
                      }));
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TxtLicitacaoFormaContratacaoSite
                    isdisabled={false}
                    isLoading={false}
                    required={false}
                    value={licitacao.modalidade}
                    handleSearchChange={it => {
                      SetLicitacao(prev => ({
                        ...prev,
                        modalidade: it as LicitacaoFormaContratacao
                      }));
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField required label="Fiscal:" name="fiscal" onChange={handleChange} size="small" inputProps={{ maxLength: 30 }} value={licitacao.fiscal} />
                  <FormHelperText>{licitacao.fiscal?.length}/50 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Box>
                  <Accordion defaultExpanded={false}>
                    <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                      <Typography color="secondary" variant="body1" gutterBottom>
                        Anexos
                      </Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Paper>
                        <GeralAnexosUpload
                          arquivosSalvos={licitacaoAnexoSalvo ?? null}
                          arquivosParaSalvar={licitacaoAnexoParaSalvar}
                          onFileChange={handleFileAnexoChange}
                          onDeleteSalvo={handleOnDeleteSalvo}
                          onDeleteParaSalvar={handleOnDeleteParaSalvar}
                          onDeleteAll={handleExcluirTodosAnexos}
                          tipo="LICITACAO"
                        />
                      </Paper>
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" gap={2}>
                  <Button type="submit" variant="contained" color="secondary">
                    Gravar
                  </Button>

                  <Button variant="contained" onClick={() => navigate(configSiteUrls.SITE_LICITACAO_LIST)} color="primary">
                    Voltar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </>
  );
};
